import { render } from "./CreateFolderModal.vue?vue&type=template&id=4c2863f6&ts=true"
import script from "./CreateFolderModal.vue?vue&type=script&lang=ts"
export * from "./CreateFolderModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__